<div class='container'>
  <mat-accordion>
    <mat-expansion-panel [expanded]="true" (opened)="panelOpenState = true"
                         (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="title">Registergoederen</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table *ngIf='showTable; else errorTextField' mat-table [dataSource]="tableData" class="collateral-objects-table">
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef> Adres </th>
          <td mat-cell *matCellDef="let data">{{data.address ? data.address : emptyValuePlaceholder}}</td>
        </ng-container>

        <ng-container matColumnDef="executionValueAmount">
          <th mat-header-cell *matHeaderCellDef> Executie waarde </th>
          <td mat-cell *matCellDef="let data">{{ formatAmount(data.executionValueAmount, 'EUR')}}</td>
        </ng-container>

        <ng-container matColumnDef="liquidationValueAmount">
          <th mat-header-cell *matHeaderCellDef> Vrije verkoopwaarde </th>
          <td mat-cell *matCellDef="let data">{{ formatAmount(data.liquidationValueAmount, 'EUR') }}</td>
        </ng-container>

        <ng-container matColumnDef="taxationDate">
          <th mat-header-cell *matHeaderCellDef> Taxatie datum </th>
          <td mat-cell *matCellDef="let data">{{data.taxationDate ? data.taxationDate : emptyValuePlaceholder}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
      </table>
      <ng-template #errorTextField>
        <div class="error-text">
          {{errorText}}
        </div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>

